// src/v3/BodyLink/index.tsx
import { forwardRef, useContext } from "react";
import { cx } from "class-variance-authority";

// src/contexts/ComponentProvider.tsx
import { createContext, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
var Context = createContext(null);
function ComponentProvider({
  children,
  ImageComponent,
  LinkComponent
}) {
  const contextValue = useMemo(
    () => ({ ImageComponent, LinkComponent }),
    [ImageComponent, LinkComponent]
  );
  return /* @__PURE__ */ jsx(Context.Provider, {
    value: contextValue,
    children
  });
}
ComponentProvider.displayName = "ComponentProvider";

// src/v3/BodyLink/index.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var BodyLink = forwardRef(
  function BodyLink2({
    children,
    className,
    color = "sandstone-500",
    external = false,
    href = "",
    onClick,
    ...rest
  }, ref) {
    const context = useContext(Context);
    const LinkComponent = external || !(context == null ? void 0 : context.LinkComponent) ? "a" : context.LinkComponent;
    return /* @__PURE__ */ jsx2(LinkComponent, {
      "data-cy": "body_link",
      ...rest,
      className: cx(`ui-underline ui-text-${color}`, className),
      href,
      onClick: (evt) => onClick == null ? void 0 : onClick(evt),
      ref,
      children
    });
  }
);
BodyLink.displayName = "BodyLink";
var BodyLink_default = BodyLink;
export {
  BodyLink,
  BodyLink_default as default
};
//# sourceMappingURL=index.mjs.map